import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { InputField } from "../../InputField/InputField";
import Button from "../../../components/Button";
// ------------------- css
import "./style.css";
import { useEffect } from "react";
import { api } from "../../../api/url";

// ------------------- validator
const LoginSchema = Yup.object().shape({
  phonenumber: Yup.string()
    .required("فیلد شماره‌موبایل الزامی می‌باشد")
    .matches(/^09[0|1|2|3|9][0-9]{8}$/, "فرمت شماره‌موبایل صحیح نمی‌باشد"),
});

const GetPhoneNumber = (props) => {
  // ------------------- get otp
  const GetOtp = async (phonenumber, setSubmitting) => {
    await axios({
      url: api + "appointment/login/getotp/" + phonenumber,
      method: "get",
    })
      .then((res) => {
        props.setStep(2);
        setSubmitting(false);
      })
      .catch((err) => {
        setSubmitting(false);
      });
  };


  const Checkuser = async (phonenumber, setSubmitting) => {
    props.setUserInfo({ ...props.userInfo, mobileNo: phonenumber });

    await axios({
      url: api + "appointment/user/checkexistbymobileno/" + phonenumber + '/',
      method: "get",
    })
      .then((res) => {
        console.log('res.data.successfull', res.data.successfull)
        if (res.data.successfull === true) {
          GetOtp(phonenumber, setSubmitting);
        } else {
          props.setStep(1);
        }
        // console.log('data',res.data.successfull)
        setSubmitting(false);
      })
      .catch((err) => {
        setSubmitting(false);
      });
  };


  // /api/appointment/user/checkexistbymobileno/{mobileNo}

  useEffect(() => {
    document.querySelector(`#phone`)?.focus();
  }, []);

  return (
    <div className="modal-phonenumber-container">
      <h5>ورود/ثبت نام</h5>
      <p>لطفا شماره موبايل خود را وارد کنيد</p>
      <Formik
        initialValues={{
          phonenumber: props.userInfo.mobileNo,
        }}
        validationSchema={LoginSchema}
        onSubmit={(values, { setSubmitting }) => {
          Checkuser(values.phonenumber, setSubmitting);
        }}
      >
        {({ isSubmitting, submitForm, errors, touched }) => (
          <Form>
            <div className="profile-field-section">
              <InputField
                id={"phone"}
                inputstyle={{
                  textAlign: "left",
                  width: "100%",
                  paddingLeft: 10,
                }}
                type="tel"
                style={{ marginBottom: 0 }}
                placeholder="09"
                name="phonenumber"
                title="شماره موبایل"
                error={
                  errors.email_number &&
                  touched.email_number &&
                  errors.email_number
                }
              />
            </div>
            <span className="helper-text">مثال:*******0912</span>
            <Button
              className="modal-phonenumber-container-button "
              onClick={submitForm}
              isSubmitting={isSubmitting}
            >
              دریافت کد
            </Button>
          </Form>
        )}
      </Formik>

      <span className="rules-paragraph">
        {"ورود شما به معنای"}
        <a target="_blank" href="/rules">
          {" پذیرش شرایط وبسلا"}{" "}
        </a>
        {"و"}
        <a target="_blank" href="/rules">
          {"قوانین حریم‌خصوصی "}
        </a>
        است.
      </span>
    </div>
  );
};

export default GetPhoneNumber;
